import React, { ReactNode } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { getAnimations } from '../../animations/animations';
import useReducedMotion from '../../hooks/useReducedMotion';

interface PageTransitionProps {
  children: ReactNode;
  transitionKey: string | number;
  className?: string;
  animation?: 'fadeIn' | 'slideUp' | 'slideDown' | 'slideLeft' | 'slideRight' | 'scale';
}

// Cast motion.div to avoid TS2590 from framer-motion's overly complex union types
const MotionDiv = motion.div as any;

export const PageTransition: React.FC<PageTransitionProps> = ({
  children,
  transitionKey,
  className = '',
  animation = 'fadeIn',
}) => {
  const prefersReducedMotion = useReducedMotion();
  const animations = getAnimations(prefersReducedMotion);
  const selectedAnimation = animations[animation];

  return (
    <AnimatePresence mode="wait">
      <MotionDiv
        key={transitionKey}
        initial={selectedAnimation?.initial || { opacity: 0 }}
        animate={selectedAnimation?.animate || { opacity: 1 }}
        exit={selectedAnimation?.exit || { opacity: 0 }}
        transition={selectedAnimation?.transition || { duration: prefersReducedMotion ? 0 : 0.3 }}
        className={className}
      >
        {children}
      </MotionDiv>
    </AnimatePresence>
  );
};

export default PageTransition;
